import apiClient from './client'

/**
 * Счётчик открытий прежнего интерфейса (редизайн, этап 5): по нему решается,
 * когда прежний интерфейс можно убрать. Экраны - маршруты без id и имён.
 */
export interface LegacyUIEventRequest {
  /** switch - нажали «Открыть прежнюю версию»; launch - запущен прежний интерфейс */
  event: 'switch' | 'launch'
  platform: 'telegram' | 'max' | 'web'
  screen?: string
  from_screen?: string
}

export const legacyUiApi = {
  // POST /api/v1/legacy-ui/events - 204
  record: async (body: LegacyUIEventRequest): Promise<void> => {
    await apiClient.post('/legacy-ui/events', body)
  },
}
